/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import * as queryString from 'query-string';

import { getApiAxiosInstance } from '../../utils/network';
import { eventMeta } from '../../api/tmsEventsApi';
import EventEditPageV2 from './EventEditPageV2';
import CreatePlayPage from '../CreatePlayPage';
import CreatePaidHitPage from '../CreatePaidHitPage';
import requireAuth from '../../components/hocs/requireAuth';
import withStatsigEventUpdate from '../../components/hocs/withStatsigEventUpdate';
import { EventTypes } from '../../utils/events';

const EventEditWrapper = props => {
    const {
        match,
        location,
        history,
    } = props;
    const parsed = queryString.parse(location?.search);
    const isDuplicating = !!parsed.cloned;

    const [loading, setLoading] = useState(true);
    const [eventMetadata, setEventMetadata] = useState({});

    useEffect(() => {
        async function prefetch() {
            try {
                const axiosInstance = getApiAxiosInstance();
                const response = await eventMeta(axiosInstance, match.params.eventId);
                if (!response.error) {
                    if (!response.data?.type) {
                        console.error('Metadata missing event type');
                    }
                    setEventMetadata(response.data);
                    setLoading(false);
                    return;
                }
                console.error(response.error);
            } catch (error) {
                console.error(error);
            }

            history.push('/');
        }
        prefetch();
    }, []);

    if (loading) {
        // splash state was already dispatched elsewhere
        return null;
    }

    // if no longer loading and eventMetadata is still null, let this
    // throw and render SWW
    switch (eventMetadata.type) {
        case EventTypes.FREE_PLAY:
            return <CreatePlayPage {...props} isEditingEvent={true} />;
        case EventTypes.PAID_HIT:
            return <CreatePaidHitPage {...props} isEditingEvent={true} isDuplicating={isDuplicating} />;
        default:
            return <EventEditPageV2 {...props} />;
    }
};

export default requireAuth(withStatsigEventUpdate(EventEditWrapper));
